
import React from 'react';
import { Brand } from '../types';

interface BrandsSectionProps {
  brands: Brand[];
}

const BrandsSection: React.FC<BrandsSectionProps> = ({ brands }) => {
  if (brands.length === 0) return null;

  return (
    <section id="brands" className="py-24 bg-slate-50 dark:bg-slate-950 border-t border-slate-100 dark:border-slate-900 transition-colors">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-blue-800 dark:text-blue-400 font-black text-[10px] uppercase tracking-[0.5em] mb-3">Our Clients</h2>
          <h3 className="text-4xl md:text-5xl font-black text-slate-900 dark:text-white uppercase tracking-tighter leading-none">
            Trusted by <span className="text-blue-600">Industry Leaders</span>
          </h3>
          <p className="mt-4 text-slate-500 dark:text-slate-400 font-medium max-w-2xl mx-auto">
            We take pride in our collaborations with top-tier organizations across the infrastructure and construction sectors.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {brands.map((brand) => (
            <div 
              key={brand.id} 
              className="group bg-white dark:bg-slate-900 rounded-[2rem] overflow-hidden border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-2xl hover:shadow-blue-900/10 transition-all duration-500 hover:-translate-y-2"
            >
              {/* Hero Logo Area */}
              <div className="h-48 bg-white flex items-center justify-center p-8 relative overflow-hidden">
                <div className="absolute inset-0 bg-slate-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <img 
                  src={brand.imageUrl} 
                  alt={brand.name} 
                  className="max-h-full max-w-full object-contain relative z-10 transition-transform duration-500 group-hover:scale-110"
                  referrerPolicy="no-referrer"
                />
              </div>

              {/* Client Info */}
              <div className="p-8 border-t border-slate-100 dark:border-slate-800">
                {brand.abbreviation && (
                  <span className="inline-block px-3 py-1 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-[10px] font-black uppercase tracking-widest rounded-full mb-3">
                    {brand.abbreviation}
                  </span>
                )}
                <h4 className="text-lg font-black text-slate-900 dark:text-white uppercase tracking-tight leading-tight group-hover:text-blue-600 transition-colors">
                  {brand.name}
                </h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
